import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  const toggle = (index: number) => {
    setOpenIndex((cur) => (cur === index ? -1 : index));
  };

  return (
    <section id="faq" className="border-t border-background-200 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-4">
            <span className="text-xs font-medium uppercase tracking-widest text-primary-600">
              常见问题
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
              地址、线路与下载的常见疑问
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              这里是用户问得最多的几个问题。如果下面没有覆盖你的情况，
              也可以先回到「最新地址」换条线路试试，多数访问问题都能这样解决。
            </p>

            <div className="mt-6 flex items-center gap-3 rounded-xl border border-accent-200 bg-accent-50 p-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-customer-service-2-line text-xl" aria-hidden="true"></i>
              </span>
              <p className="text-sm leading-relaxed text-foreground-800">
                打不开时优先切换线路，其次检查网络，最后回本页看是否有更新。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-100">
              {faqs.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={item.q} className="border-b border-background-200 last:border-b-0">
                    <button
                      type="button"
                      onClick={() => toggle(index)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-50 md:px-6 md:py-5"
                    >
                      <span className="flex items-start gap-3">
                        <span className="mt-0.5 font-heading text-sm text-primary-500">
                          Q{String(index + 1).padStart(2, "0")}
                        </span>
                        <span className="text-sm font-medium text-foreground-950 md:text-base">
                          {item.q}
                        </span>
                      </span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                          isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                        }`}
                      >
                        <i
                          className={`text-base ${isOpen ? "ri-subtract-line" : "ri-add-line"}`}
                          aria-hidden="true"
                        ></i>
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 md:px-6 md:pb-6">
                        <p className="ml-0 text-sm leading-relaxed text-foreground-700 md:ml-7">
                          {item.a}
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}